/**
 * The amber "Admin" pill: this part is only shown to admins.
 *
 * One look everywhere - the admin-only Settings tabs, Connections, and the
 * admin parts of a room - so "only admins see this" reads the same at every
 * level.
 */
export default function AdminPill({ className = '' }: { className?: string }) {
  return (
    <span
      className={`text-xs bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300 px-1.5 py-0.5 rounded font-medium ${className}`}
    >
      Admin
    </span>
  );
}

/** The outline around an admin-only block, in the same amber. */
export const ADMIN_BOX =
  'rounded-lg border border-amber-200 bg-amber-50/40 dark:border-amber-800/60 dark:bg-amber-900/10';

/** Text for an admin-only figure inside a table everyone sees. */
export const ADMIN_TEXT = 'text-amber-700 dark:text-amber-300';
